var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarCaucYoungF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 101,
    viewBox: "0 0 73 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0894 100.873C29.4334 100.873 24.0254 95.8498 24.0254 89.5458V67.3833H48.1534V89.5458C48.1534 95.8498 42.7454 100.873 36.0894 100.873Z",
    fill: "#FFC8BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1533 64.2313V70.6338C47.2173 73.5888 43.6813 76.5438 40.8733 77.6273C39.0013 78.4153 36.8173 78.6123 34.8413 78.0213C27.4573 75.9528 22.0493 65.8073 22.0493 65.8073C35.5693 74.9678 48.1533 64.2313 48.1533 64.2313Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9053 52.6084V51.1309L61.4653 44.1374L62.8173 39.0154C62.8173 39.0154 65.7293 31.5294 71.1373 35.6664C76.4413 39.8034 66.9773 57.2379 61.4653 53.3964L59.9053 52.6084Z",
    fill: "#FFC8BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3694 40.8869C69.3694 40.8869 65.4174 39.6064 62.6094 45.2209",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4814 42.4629C64.4814 42.4629 68.8494 44.6299 65.9374 47.9789",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4412 26.9984C63.4412 37.9319 61.7772 47.3879 60.2172 54.0859C58.6572 60.6854 54.1852 65.2164 47.9452 68.9594L46.9052 69.5504C40.2492 73.4904 31.7212 73.5889 25.0652 69.8459C18.2012 66.0044 13.5212 61.0794 12.0652 53.9874C9.3612 41.1824 9.15321 26.9984 9.15321 26.9984C9.15321 26.9984 6.55321 -0.581636 35.8812 0.00936432C65.2092 0.501864 63.4412 26.9984 63.4412 26.9984Z",
    fill: "#FFC8BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2334 53.3964C5.72145 57.2379 -3.74255 39.8034 1.56145 35.6664C6.86545 31.5294 10.2974 39.9019 10.2974 39.9019L11.3374 44.4329L12.5854 51.0324V52.7069L11.2334 53.3964Z",
    fill: "#FFC8BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32959 40.8869C3.32959 40.8869 7.28159 39.6064 10.0896 45.2209",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1134 42.4629C8.1134 42.4629 3.84939 44.6299 6.65739 47.9789",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4813 47.9789L37.0253 48.5699C35.7773 48.9639 34.3213 48.3729 33.8013 47.1909C33.7319 46.9282 33.6973 46.6327 33.6973 46.3044V43.2509",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3773 37.4393C25.3773 38.6213 24.3372 39.7048 22.9852 39.7048C21.6332 39.7048 20.5933 38.6213 20.5933 37.4393C20.5933 36.1588 21.6332 35.1738 22.9852 35.1738C24.3372 35.1738 25.3773 36.1588 25.3773 37.4393Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9212 37.4393C49.9212 38.6213 48.8812 39.7048 47.5292 39.7048C46.1772 39.7048 45.1372 38.6213 45.1372 37.4393C45.1372 36.1588 46.1772 35.1738 47.5292 35.1738C48.8812 35.1738 49.9212 36.1588 49.9212 37.4393Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7214 53.5C44.7214 53.5 40.7695 54.6769 35.5695 54.6769C30.4735 54.6769 26.5214 53.5 26.5214 53.5",
    stroke: "#FF807E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCaucYoungF);
export default __webpack_public_path__ + "static/media/avatar-cauc-young-f.8eaea102cd0ba00270e111af89e08e86.svg";
export { ForwardRef as ReactComponent };